// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__cvg2L","left":"StickyBox_left__2ZqXH","right":"StickyBox_right__2usx4"};